/**
 * Utilities for redux selectors
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */

/**
 * Binds the slicer to the selector
 * @param {Function} slicer The redux slicer (selector that returns a slice of state)
 * @param {Function} selector The redux selector to bind slicers
 */
export const bindSelector = (slicer, selector) => {
  return (state, ...args) => selector(slicer(state, ...args), ...args)
}

/**
 * Binds the slicer to each selector in the object
 * Refer to: https://gist.github.com/jslatts/1c5d4d46b6e5b0ac0e917fa3b6f7968f
 * @param {Function} slicer The redux slicer (selector that returns a slice of state)
 * @param {Object} selectors The object of redux selectors to bind slicers
 */
export const bindSelectors = (slicer, selectors) => (
  Object.keys(selectors).reduce((boundMethods, methodName) => ({
    ...boundMethods,
    [methodName]: bindSelector(slicer, selectors[methodName])
  }), {})
)
